import WagerList from './wager.list';

export default {
  list: WagerList,
};
